/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const overlayStyles = () => css`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1200;
  animation: fadeIn 150ms ease-out;

  &[data-state='closed'] {
    animation: fadeOut 150ms ease-in;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`

export const contentStyles = ({ theme }: { theme: Theme }) => css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1200;
  background: ${theme.palette.background.paper};
  border-radius: ${theme.shape.borderRadius}px;
  width: auto;
  box-shadow: ${theme.shadows[6]};
  display: grid;
  pointer-events: auto !important;

  animation: zoomIn 180ms ease-out;

  &[data-state='closed'] {
    animation: zoomOut 150ms ease-in;
  }
`
export const headerStyles = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border-bottom: 1px solid #e0e0e080;
`
export const footerStyles = css`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid #e0e0e080;
`
export const titleStyles = ({ theme }: { theme: Theme }) => css`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.palette.text.primary};
`
export const descriptionStyles = ({ theme }: { theme: Theme }) => css`
  font-size: 14px;
  color: ${theme.palette.text.secondary};
`
export const closeButtonStyles = () => css`
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`
